import { Button, Typography, useTheme, Box } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../Dictionary";
import DateRangeMobileDialog from "./DateRangeMobileDialog";

import { format, isValid } from "date-fns";

export default function DatePickerMobile({
  dateRange,
  startDateString,
  endDateString,
  VUOKRAAPAKU_SPECIAL_COMPANY,
  selectedCompany,
  setSelectedTimeFrame,
  hasError,
  endTimeOk,
  fixedTimeFrames,
  startSliderValue,
  endSliderValue,
  startEndSameDay,
  dayStart,
  selectedDateRange,
  handleDateChange,
  setOpenDateRangeMobile,
  startTime,
  endTime,
  SLIDER_STEP,
  disableSameDay,
  FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA,
  setStartTime,
  selectedTimeFrame,
  throttle,
  FEATURE_FIXED_RESERVATION_TIMEFRAME,
  openDateRangeMobile,
  setEndTime,
  handleClickContinue,
  getMinimumDate,
  startTimeLabel,
  returnTimeLabel,
}) {
  const theme = useTheme();
  const { language, locale } = useContext(AppContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: "5px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          justifyContent: "center",
          position: "relative",
          transition: "ease-in-out 150ms",
          direction: "row",
          marginTop: "5px",
        }}
      >
        <Button
          fullWidth
          sx={{
            display: "flex",
            cursor: "pointer",
            padding: "10px",
            height: "70px",
            border: "1px solid lightgrey",
            bgcolor: theme.palette.primary.dialogBackground,
            borderRadius: "15px",
          }}
          onClick={() => setOpenDateRangeMobile(true)}
          disabled={!selectedCompany}
        >
          {selectedDateRange[0] == null && (
            <Typography sx={{ fontFamily: "Sofia Pro", fontSize: "16px" }}>
              {translation.get(language, "Daterange select title")}
            </Typography>
          )}
          {selectedDateRange[1] != null && (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                sx={{
                  fontFamily: "Sofia Pro",
                  fontSize: "16px",
                  color: theme.palette.primary.mainText,
                }}
              >
                {translation.get(language, "Daterange schedule text")}
              </Typography>
              {isValid(selectedDateRange[0]) && isValid(selectedDateRange[1]) && (
                <Typography variant="caption">
                  {format(selectedDateRange[0], "dd.MM HH:mm", {
                    locale: locale,
                  })}{" "}
                  -{" "}
                  {format(selectedDateRange[1], "dd.MM HH:mm", {
                    locale: locale,
                  })}
                </Typography>
              )}
            </Box>
          )}
        </Button>

        <DateRangeMobileDialog
          startTimeLabel={startTimeLabel}
          returnTimeLabel={returnTimeLabel}
          getMinimumDate={getMinimumDate}
          setOpenDateRangeMobile={setOpenDateRangeMobile}
          VUOKRAAPAKU_SPECIAL_COMPANY={VUOKRAAPAKU_SPECIAL_COMPANY}
          disableSameDay={disableSameDay}
          selectedCompany={selectedCompany}
          setSelectedTimeFrame={setSelectedTimeFrame}
          openDateRangeMobile={openDateRangeMobile}
          dateRange={dateRange}
          startTime={startTime}
          setStartTime={setStartTime}
          hasError={hasError}
          fixedTimeFrames={fixedTimeFrames}
          selectedTimeFrame={selectedTimeFrame}
          SLIDER_STEP={SLIDER_STEP}
          setEndTime={setEndTime}
          endTime={endTime}
          endDateString={endDateString}
          startDateString={startDateString}
          startSliderValue={startSliderValue}
          startEndSameDay={startEndSameDay}
          endTimeOk={endTimeOk}
          endSliderValue={endSliderValue}
          dayStart={dayStart}
          throttle={throttle}
          handleDateChange={handleDateChange}
          selectedDateRange={selectedDateRange}
          FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA={
            FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA
          }
          FEATURE_FIXED_RESERVATION_TIMEFRAME={
            FEATURE_FIXED_RESERVATION_TIMEFRAME
          }
        />
        {/*When the time is ripe, this thing will emerge from the shadows and will be ashtonishing!  */}
        {/*  <MobileDateTimePickerStart
        inputRef={inputRef}
        calendarOpen={calendarOpen}

        selectedDateRange={selectedDateRange}
        handleDateChange={handleDateChange}
        setSelectedDateRange={setSelectedDateRange}
        setInputFocusStart={setInputFocusStart}
        setInputFocusReturn={setInputFocusReturn}
        inputFocusReturn={inputFocusReturn}
        inputFocusStart={inputFocusStart}
        selectedCompany={selectedCompany}
        mobileViewPort={mobileViewPort}
      /> */}
      </Box>
    </Box>
  );
}
